import { render, staticRenderFns } from "./Plugin.vue?vue&type=template&id=3d141e88&scoped=true"
import script from "./Plugin.vue?vue&type=script&lang=ts"
export * from "./Plugin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d141e88",
  null
  
)

export default component.exports